import Card, { ICard } from '../Card';
import CardLoader from '../CardLoader';
import * as ST from '../styled';

interface ICardRow {
    rowCards: ICard[],
    arrayCount: number,
    cardGap: number,
    cardWidth: number,
    amountInRow: number,
    rowIndex: number,
    isShowAll: boolean,
    onClick: () => void,
}

const CardRow = ({ rowCards, arrayCount, cardGap, cardWidth, amountInRow, rowIndex, isShowAll, onClick }: ICardRow): JSX.Element => {

    return (<ST.CardRowWrapper cardGap={cardGap}>
        {
            rowCards.map((card, innerIndex) => {
                const currentCardNumber = (innerIndex + 1) * (rowIndex + 1);
                const isLastCardInSecondRow = (rowIndex === 1) && (innerIndex === amountInRow - 1);
                const showCardLoad = arrayCount > currentCardNumber && isLastCardInSecondRow && !isShowAll;
                return showCardLoad
                    ? <CardLoader key={'card-loader-btn'} onClick={onClick} width={cardWidth} />
                    : <Card key={'card-' + card.title} card={card} width={cardWidth} />;
            })
        }
    </ST.CardRowWrapper>);
};

export default CardRow;
